<div class="stock-mobile-common-header">
  <div class="header-container">
    <div class="header-main">
      <div class="header-left">
        <a (click)="goBack()" class="nav-icon">
          <img src="assets/img/icons/back-arrow.svg" alt="Back" class="icon-img">
        </a>
      </div>
      
      <div class="header-center">
        <span class="header-title">{{ stockMobileService.commonHeaderTitle }}</span>
      </div>
      
      <div class="header-right">
        <a (click)="goToHome()" class="nav-icon">
          <img src="assets/img/icons/home-black.svg" alt="Home" class="icon-img">
        </a>
      </div>
    </div>
    <div *ngIf="stockMobileService.hasHeaderExtraContent()" class="header-extra-content" [@slideInOut]>
      <ng-content></ng-content>
    </div>
    <div *ngIf="stockMobileService.showStepper" [@slideInOut]>
      <app-stock-mobile-stepper></app-stock-mobile-stepper>
    </div>
  </div>
</div>
